import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=0472a476&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=0472a476&prod&lang=scss&scoped=true"
import style1 from "./ImportButton.vue?vue&type=style&index=1&id=0472a476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472a476",
  null
  
)

export default component.exports